require('./bootstrap');
import flatpickr from "flatpickr";

flatpickr('.flatpickr', {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
});

// Helper function
let domReady = (cb) => {
    document.readyState === 'interactive' || document.readyState === 'complete'
        ? cb()
        : document.addEventListener('DOMContentLoaded', cb);
};

domReady(() => {
    // Display body when DOM is loaded
    document.body.style.visibility = "visible";
    document.body.style.transition = "opacity 0.25s";
    document.body.style.opacity = 100;

    // console.log(window.outerWidth > 414 ? true : false);

    // if (window.outerWidth > 414 ? true : false) {
    //     document.getElementById('addBar').click();
    //     document.getElementById('addBar').style.transform = "rotate-45";
    // }

});
